'use strict';

angular.module('route', [
    'gettext',
    'ui.router',
]);
